// collectionMetadataApi.ts
import { apiPaths, vivaApi } from '@services';
import { transformCollectionMetadata } from '../metadataMappers';
import {
    CollectionMetadataResponse,
    GetCollectionMetadataArgs,
} from '../metadataTypes';

const extendedApi = vivaApi.injectEndpoints({
    endpoints: (builder) => ({
        getCollectionMetadata: builder.query<
            CollectionMetadataResponse,
            GetCollectionMetadataArgs
        >({
            query: ({ proscopeId, nocache }) => ({
                method: 'GET',
                url: apiPaths.metadata.getCollectionMetadata(proscopeId),
                params: { nocache },
            }),
            transformResponse: transformCollectionMetadata,
            providesTags: () => [{ type: 'CollectionMetadata', id: 'LIST' }],
        }),
    }),
});

export const { useGetCollectionMetadataQuery } = extendedApi;

export default extendedApi.endpoints;
